import { Injectable } from '@angular/core'
import { MatSnackBar, MatSnackBarHorizontalPosition } from '@angular/material/snack-bar'

@Injectable({
    providedIn: 'root'
})
export class SnackbarService {
    constructor(private readonly snackBar: MatSnackBar) {}

    promtSnackBar(
        message: string,
        action = 'OK',
        duration = 10000,
        horizontalPosition: MatSnackBarHorizontalPosition = 'right',
        panelClass?: string
    ): void {
        this.snackBar.open(message, action, { duration, horizontalPosition, verticalPosition: 'bottom', panelClass })
    }

    handleError(prefix: string, message: any, showSnackbar?: boolean, action = 'OK', duration = 15000): void {
        const errorMessage = this.getErrorMessage(message, prefix)

        if (showSnackbar) {
            this.snackBar.open(errorMessage, action, {
                duration,
                panelClass: ['error-snackbar'],
                horizontalPosition: 'right',
                verticalPosition: 'bottom'
            })
        }
    }

    private getErrorMessage(err: any, prefix: string): string {
        const errMessage = 'An error has occured'
        let text = err
            ? typeof err === 'string'
                ? err
                : err.statusText
                ? err.statusText
                : err.message
                ? err.message
                : ''
            : ''
        text = text ? `${errMessage}: ${text}` : errMessage

        if (err && err.data) {
            text = this.extractInnerMessage(err.data, text)
        }
        if (err && err.error) {
            text = this.extractInnerMessage(err.error, text)
        }
        console.warn(`${prefix}: ${text}`)

        return text
    }

    private extractInnerMessage(data: any, message: string): string {
        if (data.innerException) {
            if (data.innerException.exceptionMessage) {
                message = this.addIfNotContains(message, data.innerException.exceptionMessage)
            }

            message = this.extractInnerMessage(data.innerException, message)
        } else if (data.exceptionMessage) {
            message = this.addIfNotContains(message, data.exceptionMessage)
        } else if (data.error_description) {
            message = this.addIfNotContains(message, data.error_description)
        } else if (data.message) {
            message = this.addIfNotContains(message, data.message)
        } else if (typeof data === 'string') {
            message = this.addIfNotContains(message, data)
        }

        return message
    }

    private readonly addIfNotContains = (message: string, textToAdd: string): string => {
        message = !message && message !== '' ? '' : message
        message = message.indexOf(textToAdd) === -1 ? `${message} - ${textToAdd}` : message

        return message
    }
}
